"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var multiCurrencyFinanceRatesBlockStyles = styles_1.makeStyles(function (_a) {
    var _b;
    var typography = _a.typography, palette = _a.palette, breakpoints = _a.breakpoints;
    return ({
        emphasizedText: {
            padding: '0 0 0 12px',
            fontFamily: typography.fontFamily2,
            color: palette.common.black,
            paddingBottom: '20px',
        },
        financeQuotePrice: {
            color: palette.text.primary,
            fontSize: typography.fontXL,
        },
        labelAfter: (_b = {},
            _b[breakpoints.down('sm')] = {
                padding: '0 0 0 12px',
                display: 'block',
            },
            _b),
        repaymentLabel: {
            padding: '0 0 0 12px',
        },
    });
}, { name: 'Summary_MultiCurrencyFinanceRatesBlock' });
exports.default = multiCurrencyFinanceRatesBlockStyles;
